import {IDeliveryInfo} from "../../components/DeliveryBlockInfo/interfaces";
import {defaultValueForImage, getScreenWidth, isGeneration} from "./functions";

const services: IDeliveryInfo[] = [
  {
    title: 'Курьером до двери',
    price: '250',
    idHash: 'courier',
    cards: [
      {
        logo: isGeneration ? defaultValueForImage : require(`./img/DeliveryBlockInfo/logo-dalli.svg`).default,
        logoWidth: '93px',
        description: {
          title: 'Команда Dalli',
          text: `Dalli является одной из ведущих логистических компаний, предлагающих широкий спектр услуг в области грузоперевозок, складирования и логистики. Наша компания предлагает разнообразные вакансии и возможности для работы, чтобы помочь вам достичь успеха и карьерного роста.`,
        },
        idHash: 'dalli',
        listGrid: [
          {
            grid: 3,
            color: '#4DC4FF',
            list: [
              'Доставка по всей России своими курьерами и через партнеров',
              'Доставляем в ЦФО, СЗФО, ПФО за 1 день',
              '1 договор — 6 служб доставки',
              'Забираем и доставляем заказы 7 дней в неделю',
              'Возвращаем наложенные платежи 2 раза в неделю',
            ],
          },
          {
            grid: 4,
            list: [
              'Более 450 опытных и вежливых курьеров',
              'Обеспечиваем выкуп более 95% заказов для 1000 клиентов',
              'Доставляем вовремя 95% заказов',
              'Доставляем в удобные интервалы в каждом городе',
            ],
          },
          {
            grid: 3,
            list: [
              'Более 10 лет опыта работы с премиальным сегментом',
              '1 линия сопровождения, с 8:00 до 22:00, ответ менее 5 минут',
              'Выделенный менеджер сопровождения решит любой вопрос',
              'Ship from store. Доставляем заказы из оффлайн-магазинов за 1 день',
              'Same day — забираем и доставляем заказы день в день',
              'Готовые интеграции Insales, Bitrix, RetailCRM. Открытое API. Удобный личный кабинет',
            ],
          },
        ],
        mobListGrig: [
          {
            grid: 3,
            color: '#4DC4FF',
            list: [
              'Доставка по всей России своими курьерами и через партнеров',
              'Доставляем в ЦФО, СЗФО, ПФО за 1 день',
              '1 договор — 6 служб доставки',
              'Забираем и доставляем заказы 7 дней в неделю',
              'Возвращаем наложенные платежи 2 раза в неделю',

              'Более 450 опытных и вежливых курьеров',
              'Обеспечиваем выкуп более 95% заказов для 1000 клиентов',
              'Доставляем вовремя 95% заказов',
              'Доставляем в удобные интервалы в каждом городе',

              'Более 10 лет опыта работы с премиальным сегментом',
              '1 линия сопровождения, с 8:00 до 22:00, ответ менее 5 минут',
              'Выделенный менеджер сопровождения решит любой вопрос',
              'Ship from store. Доставляем заказы из оффлайн-магазинов за 1 день',
              'Same day — забираем и доставляем заказы день в день',
              'Готовые интеграции Insales, Bitrix, RetailCRM. Открытое API. Удобный личный кабинет',
            ],
          },
        ],
        tariffs: {
          title: 'курьером до двери Dalli',
          headTable: [],
          dataTariffs: [],
          headDopTable: [],
          dataDopTariffs: [],
          list: [],
        },
        height: 1224,
        heightMob: 732,
      },
    ],
  },
  {
    title: 'Почта России',
    price: '' + 130,
    idHash: 'ru',
    cards: [
      {
        logo: isGeneration ? defaultValueForImage : require(`./img/DeliveryBlockInfo/logo-ru-post.png`).default,
        logoWidth: getScreenWidth() > 720 ? 'auto' : '100%',
        listGrid: [
          {
            grid: 3,
            color: '#1937FF',
            list: [
              'Более 21 тыс. населенных пунктов',
              'Пункты выдачи в шаговой доступности',
              'Работа 7 дней в неделю в 300 городах',
              'Работа 7 дней в неделю в 300 городах',
              'Более 21 тыс. населенных пунктов',
            ],
          },
        ],
        tariffs: {
          title: 'доставка Почтой России',
          headTable: [
            '',
            'Тариф Посылка онлайн (от 1 кг.)',
            // 'Тариф Курьер онлайн (от 1 кг.)',
            'Тариф Посылка нестандартная (от 0.5 кг.)',
            'Тариф Посылка 1-го класса (от 0.1 кг.)',
          ],
          dataTariffs: [
            [
              'Мск',
              '<span>от 110 р.</span>',
              // '<span>от 230 р.</span>',
              '-',
              '-',
            ],
            [
              'МО',
              '<span>от 171 р.</span>',
              // '<span>от 230 р.</span>',
              '-',
              '-',
            ],
            [
              'СПб',
              '<span>от 153 р.</span>',
              // '<span>от 249 р.</span>',
              '<span>от 285 р.</span>',
              '<span>от 195 р.</span>',
            ],
            [
              'Новосибирск',
              '<span>от 458 р.</span>',
              // '<span>от 349 р.</span>',
              '<span>от 330 р.</span>',
              '<span>от 195 р.</span>',
            ],
            [
              'Казань',
              '<span>от 171 р.</span>',
              // '<span>от 249 р.</span>',
              '<span>от 271.67 р.</span>',
              '<span>от 195 р.</span>',
            ],
            [
              'Челябинск',
              '<span>от 173 р.</span>',
              // '<span>от 287 р.</span>',
              '<span>от 288.33 р.</span>',
              '<span>от 195 р.</span>',
            ],
            [
              'Самара',
              '<span>от 171 р.</span>',
              // '<span>от 249 р.</span>',
              '<span>от 310 р.</span>',
              '<span>от 195 р.</span>',
            ],
            [
              'Омск',
              '<span>от 287 р.</span>',
              // '<span>от 359 р.</span>',
              '<span>от 330 р.</span>',
              '<span>от 195 р.</span>',
            ],
            [
              'Ростов-на-Дону',
              '<span>от 259 р.</span>',
              // '<span>от 284.17 р.</span>',
              '',
              '<span>от 195 р.</span>',
            ],
            [
              'Уфа',
              '<span>от 219 р.</span>',
              // '<span>от 249 р.</span>',
              '<span>от 284.17 р.</span>',
              '<span>от 195 р.</span>',
            ],
            [
              'Красноярск',
              '<span>от 404 р.</span>',
              // '<span>от 393 р.</span>',
              '<span>от 261.67 р.</span>',
              '<span>от 195 р.</span>',
            ],
            [
              'Пермь',
              '<span>от 175 р.</span>',
              // '<span>от 299 р.</span>',
              '<span>от 321.67 р.</span>',
              '<span>от 195 р.</span>',
            ],
            [
              'Краснодар',
              '<span>от 202 р.</span>',
              // '<span>от 249 р.</span>',
              '<span>от 316.67 р.</span>',
              '<span>от 195 р.</span>',
            ],
          ],
          headDopTable: ['Доп. услуги', ''],
          dataDopTariffs: [
            ['Почтовый тариф за возврат посылок всех категорий', '100 % прямой почтовый тариф'],
            ['Обработка возвратных почтовых отправлений без вскрытия', '27 р.</span>'],
            ['Предпочтовая обработка', '50 р.</span>'],
            ['Операция доупаковки (без учёта стоимости материала)', '20 р.</span>'],
            ['Розыск почтовых отправлений с подачей официального заявления', '180 р.</span>'],
            ['Розыск почтовых отправлений без подачи заявления', '10 р.</span>'],
            [
              'Информационное сопровождение при необходимости смены адреса получателя (досыл отправления): составление запроса на досыл отправления, передача запроса в отделение АО «Почта России»',
              '120 р.</span>',
            ],
            ['Страховой сбор', '0,6%'],
            ['Наличные ДС', '2,7%'],
            ['Оплата по карте', '2,7%'],
          ],
          list: [
          ],
        },
        height: 412,
        heightMob: 356,
      },
    ],
  },
];

const svgBgDalli = (
  <svg width="724" height="924" viewBox="0 0 1100 1300" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5" filter="url(#filter0_f_4037_5392)">
      <path
        d="M679.974 679.974C599.718 760.23 437.068 727.7 316.684 607.316C196.3 486.932 163.77 324.282 244.026 244.026C324.282 163.77 486.932 196.3 607.316 316.684C727.7 437.068 760.23 599.718 679.974 679.974Z"
        fill="#4DC4FF"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_4037_5392"
        x="0"
        y="0"
        width="924"
        height="924"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_4037_5392"/>
      </filter>
    </defs>
  </svg>
);

const svgBg = (color?: string) => {
  return (
    <svg width="740" height="740" viewBox="0 0 740 740" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5" filter="url(#filter0_f_4195_5281)">
        <path
          d="M511.434 511.434C459.359 563.508 353.823 542.401 275.711 464.289C197.599 386.177 176.492 280.641 228.566 228.566C280.641 176.492 386.177 197.599 464.289 275.711C542.401 353.823 563.508 459.359 511.434 511.434Z"
          fill={color ? color : 'none'}
        />
      </g>
      <defs>
        <filter
          id="filter0_f_4195_5281"
          x="0"
          y="0"
          width="740"
          height="740"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_4195_5281"/>
        </filter>
      </defs>
    </svg>
  );
};

export default {
  textButton: 'Тарифы и доп. услуги',
  textModalTitle: 'ZOOM с менеджером',
  textModalButton: 'Отправить заявку',
  textTariffs: 'Тарифы',
  services,
  svgBgDalli: isGeneration ? defaultValueForImage : svgBgDalli,
}
